export default __webpack_public_path__ + "static/media/Programming-Pathshala.71c9c4f9.jpg";